import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { SmallChevronUp, SmallChevronDown } from '../../../../../../images/common'
import { generateKeyFindingFields, dashboardForm } from '../utils'

export const KeyFinding = ({
  label = '',
  value = '',
  values = {},
  onChange = (val) => null,
  placeholder = '',
  color,
  id
}) => {
  const keyFindingFields = useMemo(
    () => generateKeyFindingFields({ data: values, color }),
    [values, color]
  )
  const formProps = useMemo(() => ({ color: color, fieldsGap: 8 }), [color])

  const onFormChange = (data, value, more) => {
    onChange(data, value, more)
  }

  return <div>
    {dashboardForm({
    description: '',
    fields: keyFindingFields,
    onFormChange: onFormChange,
    formProps
  })}</div>
}